// 두 자리 숫자로 맞춘다.
const pad = value => String(value).padStart(2, '0');

// 시각(ms 또는 날짜 문자열)을 YYYY.MM.DD로 바꾼다. 없거나 잘못된 값이면 '—'.
export function formatDate(value) {
    const date = new Date(value);
    return value == null || Number.isNaN(date.getTime()) ? '—' : `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())}`;
}

// 면담 인스턴스로 ReviewLayout의 면담 정보 카드 값을 만든다.
export function toReviewSession(instance, date) {
    const client = instance.client || {};
    return {
        name: client.name, profile: `${client.age}세 · ${client.occupation}`, title: client.title,
        date: formatDate(date), duration: `${instance.durationMinutes}분`, model: 'MI · 동기면담',
    };
}
